module.exports = __webpack_public_path__ + "static/media/when-you-walk.3bcd9c44.mp3";